import * as React from 'react';
import { Component } from 'react';
import { CheckBoxComponent } from '../../controls/CheckBox';
import { store } from '../..';
import * as Actions from '../../actions/ActionsIndex';
import { Redirect } from 'react-router';
import { SchedulerService } from '../../services/SchedulerService';
import { WEEKDAYS_LONG } from '../../constants/DateConsts';
import * as moment from 'moment';

interface IProps {
    Phone?: string,
    ClosePhoneModal: () => void,
    PhysiotherapistId?: string,
    ClinicId: number,
    IsHomeService?: boolean
}

interface IState {
    PhoneNumberVisible: boolean,
    Redirect: boolean,
    StartTime?: Date
}

export class PhoneModalComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            PhoneNumberVisible: false,
            Redirect: false
        }

        this.ShowPhoneNumber = this.ShowPhoneNumber.bind(this);
        this.StartVisitClick = this.StartVisitClick.bind(this);
        this.GetClosestAvailableVisitDate = this.GetClosestAvailableVisitDate.bind(this);
        this.OnGetClosestAvailableVisitDateSuccess = this.OnGetClosestAvailableVisitDateSuccess.bind(this);
        this.OnGetClosestAvailableVisitDateError = this.OnGetClosestAvailableVisitDateError.bind(this);

        this.GetClosestAvailableVisitDate();
    }

    public componentWillMount() {
        document.body.classList.add('with-modal');
    }

    public componentWillUnmount() {
        document.body.classList.remove('with-modal');
    }

    public render() {
        const scrollTop = window.scrollY;
        return (
            <div className="phone-modal-component">
                {this.RenderRedirect()}
                <div className="modal" style={{ top: `${scrollTop}px` }}>
                    <div className="modal-main section">
                        <div className="close-btn" onClick={this.props.ClosePhoneModal} />
                        <div className="header">
                            <h3 className="title">Numer telefonu</h3>
                            {
                                this.state.PhoneNumberVisible ?
                                    (<span className="phone-number">{this.props.Phone}</span>) :
                                    (<CheckBoxComponent
                                        Checked={false}
                                        Label={"Prosimy o zaznaczenie tego pola, aby zobaczyć numer fizjoterapeuty w serwisie ZnajdzFizjoterapeute.pl"}
                                        OnClick={this.ShowPhoneNumber}
                                    />)
                            }
                        </div>
                        {
                            this.state.StartTime !== undefined && !this.props.IsHomeService ?
                                (<div className="start-visit-section">
                                    <h3 className="title">Nie czekaj - zarezerwuj teraz w aplikacji!</h3>
                                    <div className="start-visit-section-content">
                                        Wygoda i oszczędność czasu - rezerwuj przez aplikację:<br />
                                        Wybierz termin dostępny w grafiku fizjoterapeuty i umów wizytę<br />
                                        - szybko i bez konieczności dzwonienia. Wkrótce dostaniesz<br />
                                        potwierdzenie rezerwacji oraz przypomnienie o terminie wizyty.
                                    </div>
                                    <div className="start-visit-section-button">
                                        <h4>Najbliższy wolny termin:</h4>
                                        <button onClick={this.StartVisitClick}>
                                            {
                                                WEEKDAYS_LONG[this.state.StartTime.getDay()]
                                                + ', ' + moment(this.state.StartTime).format('DD.MM')
                                                + ', ' + moment(this.state.StartTime).format('HH:mm')
                                            }
                                        </button>
                                    </div>
                                </div>) :
                                null

                        }
                    </div>
                </div>
            </div>
        );
    }

    private RenderRedirect() {
        if (this.state.Redirect) {
            return (
                <Redirect to={'/arrangevisit/firststep'} push={true} />
            );
        } else {
            return null;
        }
    }

    private StartVisitClick() {
        if (this.state.StartTime) {
            store.dispatch(Actions.SetVisitInfo({
                PhysiotherapistId: this.props.PhysiotherapistId,
                ClinicId: this.props.ClinicId,
                StartTime: this.state.StartTime
            }));
        }
        this.setState({
            Redirect: true
        });
    }

    private ShowPhoneNumber() {
        this.setState({
            PhoneNumberVisible: true
        });
    }

    private GetClosestAvailableVisitDate() {
        if (this.props.PhysiotherapistId) {
            let service = new SchedulerService();
            service.GetClosestAvailableVisitDate(
                this.props.PhysiotherapistId,
                this.props.ClinicId,
                this.OnGetClosestAvailableVisitDateSuccess,
                this.OnGetClosestAvailableVisitDateError);
        }
    }

    private OnGetClosestAvailableVisitDateSuccess(result) {
        if (result.data !== undefined &&
            result.data !== null &&
            result.data !== "" &&
            result.data !== "null") {
            let newStartTime = new Date(result.data);
            this.setState({
                StartTime: newStartTime
            });
        }
    }

    private OnGetClosestAvailableVisitDateError(error) {
        console.error("Nie udało się pobrać najbliższego wolnego terminu");
    }
}


// WEBPACK FOOTER //
// ./src/components/Clinic/PhoneModal.tsx